import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { fetchTokenActionCreator } from './action-creators/fetch-token-action-creator';
import { AuthState, PayloadInitializeAuthorization } from './types';

const initialState: AuthState = {
  authenticating: false,
  failed: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    initializeAuthorization: (state, action: PayloadAction<PayloadInitializeAuthorization>) => {
      state.authenticationKey = action.payload.authenticationKey;
      state.codeVerifier = action.payload.codeVerifier;
    },
    resetAuth: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTokenActionCreator.pending, (state) => {
      state.authenticating = true;
    });
    builder.addCase(fetchTokenActionCreator.fulfilled, (state, action) => {
      state.authToken = action.payload;
      state.failed = false;
      state.authenticating = false;
    });
    builder.addCase(fetchTokenActionCreator.rejected, (state) => {
      state.authToken = undefined;
      state.authenticating = false;
      state.failed = true;
    });
  },
});

export const {
  actions: { resetAuth, initializeAuthorization },
  reducer: authSliceReducer,
} = authSlice;
